import { useMemo } from 'react';
import type { ElasticListVehicle } from '@//app/api/search/vehicles';
import { type CfitImage, urlToCfit } from '@//utils/image/urlToCfit';

const assetPrefix = process.env.NEXT_PUBLIC_ASSETS_CDN || '';

const fallbackImage: CfitImage = {
  src: `${assetPrefix}/images/product-card/placeholder.jpg`,
  srcSet: `${assetPrefix}/images/product-card/placeholder@2x.jpg 2x`,
  alt: 'Image missing',
  width: 450,
  height: 299,
};

const useProductCardContainerImage = (
  item: ElasticListVehicle,
  loading: React.ImgHTMLAttributes<HTMLImageElement>['loading'],
) => {
  const image = useMemo(() => {
    const url = item.featuredImage?.files?.[0]?.url;
    return url ? urlToCfit(url, { width: 450, alt: item.title, loading }) : fallbackImage;
  }, [item.featuredImage?.files, item.title]);
  return image;
};

export default useProductCardContainerImage;
